import * as yup from "yup"

export const validationSchema = yup.object().shape({
    mr_comparation_code: yup.string().label("Comparation code").required().min(2).max(3),
    mr_comparation_name: yup.number().label("Comparation").typeError("Comparation is a required field").required().test('len', 'Must be exactly 3 characters', val => val.toString().length <= 2).test('max-value','Comparation name value must not exceed 20', val => val <= 20),
    description: yup.string().label("Description").optional()
  })
